var utils = (function($) {

    function matchCurrentRoute(routes) {
        var urlPathname = window.location.pathname;

        return routes.find(function(route) {
            return route.url === urlPathname
        });
    }

    return {
        matchCurrentRoute: matchCurrentRoute,
    }

})(jQuery);

